import { render, staticRenderFns } from "./step-object.vue?vue&type=template&id=6880b0f4&"
import script from "./step-object.vue?vue&type=script&lang=js&"
export * from "./step-object.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports